import { CiBoxes } from "react-icons/ci";
import { AiOutlineTag } from "react-icons/ai";
import { SiCivicrm } from "react-icons/si";
import { IoMoveOutline } from "react-icons/io5";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { LuWarehouse, LuArrowLeftRight } from "react-icons/lu";

const sidebar = [
  {
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/inventory/home'
  },
  {
    titleKey: "sidebar.warehouses",
    title: "Warehouses",
    icon: <LuWarehouse />,
    link: '/inventory/warehouses',
    permission: 'inventory.warehouses.view'
  },
  {
    titleKey: "sidebar.categories",
    title: "Categories",
    icon: <AiOutlineTag />,
    link: '/inventory/categories',
    permission: 'inventory.categories.view'
  },
  {
    titleKey: "sidebar.products",
    title: "Products",
    icon: <CiBoxes />,
    link: '/inventory/products',
    permission: 'inventory.products.view'
  },
  {
    titleKey: "sidebar.stockMovements",
    title: "Stock Movements",
    icon: <IoMoveOutline />,
    link: '/inventory/stock-movements',
    permission: 'inventory.stock_movements.view'
  },
  {
    titleKey: "sidebar.stockTransfers",
    title: "Stock Transfers",
    icon: <LuArrowLeftRight />,
    link: '/inventory/stock-transfers',
    permission: 'inventory.transfers.view'
  },
  {
    titleKey: "sidebar.stockAdjustments",
    title: "Stock Adjustments",
    icon: <HiOutlineAdjustmentsHorizontal />,
    link: '/inventory/stock-adjustments',
    permission: 'inventory.stock_adjustments.view'
  }
];

export default sidebar;
